import React from 'react'
import './SetReminderView.scss'
import { CSSTransition } from 'react-transition-group'

import { SetReminderView } from './SetReminderView'
import { SetReminderThankyouView } from './SetReminderThankyouView'

export const SetReminderWrapper = ({
  requestReminder,
  goBackToStart,
  setPosition,
  reminderFormSent,
  reminderHeader,
  reminderCopy,
  reminderThanksHeader,
  reminderThanksCopy,
  headerImage,
  instructionsHeader,
  instructions,
}) => {
  const animationDuration = 400

  return (
    <div
      className={`receipt-reminder-view reminder-transition-wrapper ${reminderFormSent}`}
    >
      <CSSTransition
        key={`reminder-form-wrapper`}
        in={reminderFormSent === false}
        timeout={animationDuration}
        className={`reminder-form-wrapper will-fade-transition ${
          reminderFormSent === false ? 'is-active' : 'is-inactive'
        }`}
      >
        <>
          {reminderFormSent === false && (
            <SetReminderView
              headline={reminderHeader}
              introCopy={reminderCopy}
              headerImage={headerImage}
              onHaveReceiptClick={goBackToStart}
              onRequestReminder={requestReminder}
            />
          )}
        </>
      </CSSTransition>
      <CSSTransition
        key={`reminder-thankyou-wrapper`}
        in={reminderFormSent === true}
        timeout={animationDuration}
        className={`reminder-thankyou-wrapper will-fade-transition ${
          reminderFormSent === true ? 'is-active' : 'is-inactive'
        }`}
      >
        <>
          {reminderFormSent === true && (
            <SetReminderThankyouView
              headline={reminderThanksHeader}
              introCopy={reminderThanksCopy}
              headerImage={headerImage}
              instructionsHeader={instructionsHeader}
              instructions={instructions}
            />
          )}
        </>
      </CSSTransition>
    </div>
  )
}
